import React from "react";
import { LANDING } from "@/constants/testIds";
import { Check } from "lucide-react";

const LOOKBOOK =
  "https://customer-assets.emergentagent.com/job_members-first/artifacts/jjh2m3iu_8214CA7D-ED39-4450-B9B8-BC62CB41BC71.png";

const FEATURES = [
  "360° Embroidered Detailing",
  "Small Batch Release — Numbered",
  "Members Receive First Access",
  "Archived Forever Once Sold Out",
];

export default function DropSection() {
  return (
    <section
      data-testid={LANDING.dropSection}
      className="relative bg-[hsl(var(--scrm-bg))] border-t hairline"
    >
      {/* Heading band */}
      <div className="px-6 md:px-10 pt-20 md:pt-28 pb-10">
        <div className="flex items-start md:items-end justify-between gap-6 flex-col md:flex-row">
          <div>
            <div className="text-[10px] tracking-eyebrow uppercase text-[hsl(var(--scrm-cream))]/55 mb-4">
              ✈ Drop 001 / Live Now
            </div>
            <h2
              data-testid={LANDING.dropTitle}
              className="font-display uppercase tracking-mega text-[hsl(var(--scrm-cream))]
                         text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.92]"
            >
              Raver Club.
            </h2>
            <div className="mt-4 font-body text-xs tracking-eyebrow uppercase text-[hsl(var(--scrm-cream))]/55">
              A story in every stitch.
            </div>
          </div>
          <p className="font-body text-sm md:text-base text-[hsl(var(--scrm-cream))]/65 max-w-md leading-relaxed">
            Inspired by underground music, late nights, warehouse parties and the
            stories that happen after dark. Detailed across 360° of fabric — never
            to be re-cut.
          </p>
        </div>
      </div>

      {/* Lookbook hero */}
      <div className="px-3 md:px-6">
        <div
          data-testid={LANDING.dropMockup("lookbook")}
          className="relative bg-[hsl(var(--scrm-bg))] border hairline border-[hsl(var(--scrm-cream))]/8 overflow-hidden"
        >
          <img
            src={LOOKBOOK}
            alt="Drop 005 — Raver Club lookbook: front, left, right, back angles, embroidered details (342, vinyl, sound system, DJ deck, wide eyes, glow stick, warehouse, red shades), inside taping, under visor and limited-edition tag"
            className="w-full h-auto block"
            loading="lazy"
          />
        </div>
      </div>

      {/* Whisper quote */}
      <div className="px-6 md:px-10 pt-12 md:pt-16 pb-2 text-center">
        <p className="font-display uppercase tracking-[0.04em] text-[hsl(var(--scrm-cream))]/85 text-xl md:text-3xl lg:text-4xl leading-tight max-w-3xl mx-auto">
          "Not a night out.<br /> A memory."
        </p>
        <p className="mt-5 font-body text-xs md:text-sm tracking-wide text-[hsl(var(--scrm-cream))]/45 max-w-md mx-auto leading-relaxed">
          For the ones who leave last. Collecting stories, sunrises and memories
          that don't need explaining.
        </p>
      </div>

      {/* Feature list */}
      <div className="px-6 md:px-10 pt-14 md:pt-20 pb-24 md:pb-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 items-start">
          <div className="md:col-span-4">
            <div className="text-[10px] tracking-eyebrow uppercase text-[hsl(var(--scrm-cream))]/55 mb-3">
              Specification
            </div>
            <h3 className="font-display uppercase tracking-tight text-2xl md:text-3xl text-[hsl(var(--scrm-cream))] leading-tight">
              Cut for the<br />few.
            </h3>
          </div>

          <ul
            data-testid={LANDING.dropFeatureList}
            className="md:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-5"
          >
            {FEATURES.map((f, i) => (
              <li
                key={f}
                className="flex items-start gap-4 border-t hairline pt-5"
              >
                <span className="font-display text-[hsl(var(--scrm-cream))]/35 text-sm pt-0.5">
                  0{i + 1}
                </span>
                <div className="flex-1 flex items-start gap-3">
                  <Check className="h-4 w-4 mt-1 text-[hsl(var(--scrm-cream))]/80" strokeWidth={1.5} />
                  <span className="font-body text-sm md:text-[15px] text-[hsl(var(--scrm-cream))]/85 leading-snug">
                    {f}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
